import { Box } from '@mui/material';

import PhoneNumber from './PhoneNumberComponent';
import TextFieldComponent from './TextFieldComponent';

const PhoneNumberWithExtension = (props) => (
  <Box width="100%" display="flex">
    <Box width="65%" pr="2rem">
      <PhoneNumber {...props} placeholder="Phone" />
    </Box>
    <Box width="35%">
      <TextFieldComponent {...props} placeholder="Extension" />
    </Box>
  </Box>
);

export default PhoneNumberWithExtension;
